import axios from "axios";
import lodash from "lodash";
import md5 from "md5";
import { checkOk, showToast, filterData } from "../libs/checkApi";
// 请求头
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencodedcharset=UTF-8";
// api 配置
let config = {
  baseURL: process.env.VUE_APP_API_ROOT,
  timeout: 10000, // 超时时间
  withCredentials: true // 设置是否允许跨域
};
// 获取当前环境
const NODE_ENV = process.env.NODE_ENV;
// 实例化
const _axios = axios.create(config);

// 请求数据拦截
_axios.interceptors.request.use(
  config => {
    let time = parseInt(lodash.now() / 1000);
    let obj = {
      request_time: time,
      request_key: "ec736721e79fffafc016c0bf815689db"
    };
    if (NODE_ENV == "production") {
      obj.request_key = "584953ab14ae7b10e51756b63e97a297";
    }
    if (config.params) {
      config.params = filterData(config.params);
    }
    if (config.data) {
      config.data = filterData(config.data);
    }

    let _data = {};
    if (config.data) {
      _data = {
        ...config.data,
        ...obj
      };
    } else if (config.params) {
      _data = {
        ...config.params,
        ...obj
      };
    } else {
      _data = { ...obj };
    }
    let str = "";
    Object.keys(_data)
      .sort()
      .forEach(key => {
        str += `${key}=${_data[key]}&`;
      });
    _data.sign = md5(str);
    delete _data.request_key;
    if (config.params) {
      config.params = { ..._data };
    } else {
      config.data = { ..._data };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 相应数据拦截
_axios.interceptors.response.use(
  response => {
    if (checkOk(response)) {
      return response.data;
    } else {
      showToast(response);
      return Promise.reject(response);
    }
  },
  error => {
    showToast(error.response);
    return Promise.reject(error.response.data);
  }
);

export default _axios;
